import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import "./index.css";
import App from "./App";
import English from "./lang/en.json";
import German from "./lang/de.json";
import appSettingsLocal from "./appsettings.LOCAL.json";
import ScreenSizeProvider from "./views/utility/ScreenSize";
import {DataMarketStyling} from "@spg/component_library/dm";
import {IntlProvider} from "react-intl";
import {AppSettings} from "./logic/APITypes";
import AppSettingsProvider from "./views/utility/AppSettingsProvider";
import KeycloakProvider from "./views/utility/KeycloakProvider";
import AuthErrorPage from "./views/AuthErrorPage";

const locale = navigator.language;

let lang = English as Record<string, string>;

if (locale.split("-")[0].toLowerCase() === "de") {
  lang = German as Record<string, string>;
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
const onSettingsLoaded = (appSettings: AppSettings) => {
  appSettings.texts.imprint.forEach((part, i) => {
    lang["imprint.titles.section" + i] = part.title;
    lang["imprint.paragraphs.section" + i] = part.paragraph;
  });
  root.render(
    <AppSettingsProvider appSettings={appSettings}>
      <KeycloakProvider>
        <React.StrictMode>
          <IntlProvider locale={locale} messages={lang}>
            <BrowserRouter>
              <ScreenSizeProvider>
                <>
                  <DataMarketStyling />
                  <App />
                </>
              </ScreenSizeProvider>
            </BrowserRouter>
          </IntlProvider>
        </React.StrictMode>
      </KeycloakProvider>
    </AppSettingsProvider>,
  );
};

const onSettingsError = () => {
  root.render(
    <IntlProvider locale={locale} messages={lang}>
      <DataMarketStyling />
      <AuthErrorPage reason={"noAppSettings"} />
    </IntlProvider>,
  );
};

if (process.env.NODE_ENV === "development") onSettingsLoaded(appSettingsLocal);
else
  fetch("/appsettings.json").then(
    (res) =>
      res
        .json()
        .then((settings) => onSettingsLoaded(settings), onSettingsError),
    onSettingsError,
  );
